import React, {FC} from 'react';
import styles from './SimpleModal.module.scss'
import clsx from "clsx";
import PlainModal from '../PlainModal';

interface SimpleModalProps {
    isOpen: boolean
    onClose?: () => void
    children: React.ReactNode
    className?: string
    disableBackdropClose?: boolean
    disableEscapeKeyDown?: boolean
}

export const SimpleModal:FC<SimpleModalProps> = ({ isOpen, onClose, children, className, disableBackdropClose, disableEscapeKeyDown }) => {
    const handleClose = disableBackdropClose ? undefined : onClose;
    return (
        <PlainModal
            rootClassName={clsx(styles.modal, className)}
            dialogClassName={styles.window}
            isOpen={isOpen}
            onClose={handleClose}
            disableBackdropClose={disableBackdropClose}
            disableEscapeKeyDown={disableEscapeKeyDown}
            ariaLabel="Modal"
            dataTestId="simple-modal"
        >
            {children}
        </PlainModal>
    );
}
